module.exports = __webpack_public_path__ + "static/media/aeff932d-f596-4ccf-80d8-2a141635ae67.1ec23e07.png";